export const currency = {
  currencySearch: "Buscar moeda...",
  currencyFiatOnly: "Só Fiat",
  currencyManage: "Gerenciar",
  currencySelectCurrency: "Selecionar moeda",
  currencyNoResults: "Nenhuma moeda encontrada",
  currencyTypeFiat: "Fiat",
  currencyTypeCrypto: "Cripto",

  currencyManageTitle: "Gerenciar moedas",
  currencyManageFiatTab: "Dinheiro Fiat",
  currencyManageCryptoTab: "Criptomoedas",
  currencyManageSearchPlaceholder: "Buscar em {type}...",
  currencyManageNoFiat: "Nenhuma moeda fiat encontrada",
  currencyManageNoCrypto: "Nenhuma criptomoeda encontrada",
  currencyManageClose: "Fechar",

  currencyName: "Moedas",
  cryptoNames: "Criptos",

  currencyVES: "Bolívares",
  currencyUSD: "Dólares",
  currencyUSDT: "Tether USD",
  currencyCLP: "Pesos chilenos",

  currencySymbolVES: "Bs.",
  currencySymbolUSD: "US$",
  currencySymbolUSDT: "₮",
  currencySymbolCLP: "CL$",

  currencyConversionError: "Erro ao converter moeda",
  currencyLoadingRates: "Carregando cotações...",
  currencyManagementNote: "Ative ou desative moedas para exibir no seletor",
};
